export enum AnnouncementPublishTimeUpdateStrategy {
  /**
   * 首次发布时间
   */
  FIRST_PUBLISHED = 0,
  /**
   * 最新发布时间
   */
  LATEST_PUBLISHED = 1
}
